<template>
<div class="breadcrumbs ace-save-state" id="breadcrumbs" ref="nav">
    <ul class="breadcrumb">
        <li v-for="(nav, key) in $route.meta.navigation" :key="key" :class="{active : nav.active}">
            <i :class="nav.class" v-if="nav.class"></i>
            <router-link :to="getTo(nav)" v-if="nav.url" :class="nav.newClass" :ref="nav.ref">{{ nav.pagina }}</router-link>
            <span v-else :class="nav.newClass" :ref="nav.ref">{{ nav.pagina }}</span>
        </li>
    </ul><!-- /.breadcrumb -->
</div>
</template>

<script>
export default {
  name: 'Navegation',
  methods: {
    getTo(nav) {
        if(nav) {
            return nav.url.replace(':id', this.$route.params.id)
        }
    }
  },
}
</script>
